import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./layouts/mainLayout";

import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Products } from "./pages/Products";
import { ProductDetail } from "./pages/ProductDetail";
import { Technology } from "./pages/Technology";
import { Contact } from "./pages/Contact";
import NotFound from "./pages/NotFound";
import ItemDetail from "./pages/ItemDetails";

import ScrollToTop from "./Components/Utilities/ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="products" element={<Products />}>
            <Route path=":productId" element={<ProductDetail />}>
              <Route path=":itemId" element={<ItemDetail />} />
            </Route>
          </Route>
          <Route path="technology" element={<Technology />} />
          <Route path="contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
